import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, Fragment, useMemo, useEffect } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import SectionList from "../../../../components/SectionList";
import ModalConfirm from "../../../../components/ModalConfirm";
import MatchingModal from "../MatchingModal";
import CreateFieldModal from "../CreateFieldModal";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'MatchFields');
const MatchFields = _ref => {
  let {
    matchBy,
    listProps,
    currentState,
    onConfirm,
    modalConfirmProps,
    matchingModalRef,
    setMatchingModalRef,
    setWidth,
    matchFieldsCreateModalProps,
    entityName,
    data
  } = _ref;
  const classes = useStyles();
  useEffect(() => {
    const updateWidth = () => {
      setWidth(document.body.scrollWidth);
    };
    setTimeout(updateWidth, 500);
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
      setMatchingModalRef(null);
    };
  }, [setWidth, setMatchingModalRef]);
  const finalListProps = useMemo(() => {
    return _objectSpread(_objectSpread({}, listProps), {}, {
      className: classes.matchFieldsList
    });
  }, [listProps, classes]);
  return /*#__PURE__*/React.createElement(Fragment, null, currentState >= 2 && /*#__PURE__*/React.createElement(SectionList, finalListProps), /*#__PURE__*/React.createElement(MatchingModal, {
    onRef: ref => !matchingModalRef && setMatchingModalRef(ref),
    onConfirm: onConfirm,
    matchBy: matchBy
  }), /*#__PURE__*/React.createElement(ModalConfirm, modalConfirmProps), /*#__PURE__*/React.createElement(CreateFieldModal, _extends({
    entityName: entityName,
    data: data
  }, matchFieldsCreateModalProps)));
};
process.env.NODE_ENV !== "production" ? MatchFields.propTypes = {} : void 0;
export default /*#__PURE__*/memo(MatchFields);